import { MobileCommControl } from "../MobileCommControl";
import { MobileCommFormGroupByVendor } from "../MobileCommFormGroupByVendor";
import { Button, DataHeader, DataSource, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlTabView extends Layout {
    buttonDrivers: Button;
    buttonForms: Button;
    buttonLocations: Button;
    buttonPortal: Button;
    buttonTerminals: Button;
    buttonTrailers: Button;
    buttonVehicles: Button;
    dataheader1: DataHeader;
    layoutMobileCommControl: MobileCommControl;
    layoutMobileCommForms: MobileCommFormGroupByVendor;
    panelTools: Panel;
    sourceMCControl: DataSource;
    sourceMobileCommForm: DataSource;
    sourceMobileCommSendLoadOptions: DataSource;
    tabControl: Tab;
    tabForms: Tab;
    tabsetMobileCommControlTabView: Tabset;
}
